import React from 'react'

export const ActionSection = ({ className = '', children }) => {
    return (
        <div className={`grid gap-1 overflow-auto ${className}`}>
            {children}
        </div>
    )
}
